import { saveAs } from 'file-saver';
import { utils, writeFileXLSX } from 'xlsx';
export function useFileSaver() {
  function downloadBlob(fileName, blob) {
    saveAs(blob, fileName);
  }
  function createCSV(headers, rows) {
    const content = `${headers.length > 0 ? `${headers.join(',')}\r\n` : ''}${rows.map(row => row.join(',')).join('\r\n')}`;
    return new Blob([content], {
      type: 'text/csv;charset=utf-8'
    });
  }
  function downloadCSV(fileName, headers, rows) {
    const blob = createCSV(headers, rows);
    downloadBlob(fileName, blob);
  }
  function downloadXLSX(fileName, headers, _rows) {
    const rows = _rows.map(row => row.map(value => typeof value === 'number' ? `${value}`.replace('.', ',') : value));
    const ws = utils.aoa_to_sheet(headers.length > 0 ? [headers, ...rows] : rows);
    ws['!cols'] = headers.map((header, index) => ({
      wch: rows.reduce((wch, row) => Math.max(wch, `${row[index]}`.length), header.length)
    }));
    const wb = utils.book_new();
    utils.book_append_sheet(wb, ws, 'Sheet1');
    writeFileXLSX(wb, fileName);
  }
  function download(url, fileName) {
    saveAs(url, fileName);
  }
  return {
    download,
    createCSV,
    downloadCSV,
    downloadXLSX,
    downloadBlob
  };
}